import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { ProgressIndicator } from "@cars24/turbo-web/lib/progress-indicator";
import { NUMBER } from "../../../constants/app-constants";
import CloseButton from "../icon-cross";
import styles from "./styles.css";
import { Label } from "@cars24/turbo-web/lib/label";
import { Chips } from "@cars24/turbo-web/lib/chips";
import { Alert } from "@cars24/turbo-web/lib/alert";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import AdsComponent from "../ads";
import { appUrl } from "../../../constants/url-constants";
import { getDeviceType } from "../../../utils/helpers/device-type";

const RtoVehInfoQuestionList = ({
    gaId,
    questions,
    version,
    handleClose,
    saveRtoQuestionConnect,
    cmsImageGallery
}) => {
    const { tokens } = useTokens();
    const { rtoQuestionOffer } = cmsImageGallery || [];
    const [offer] = rtoQuestionOffer || [];
    const [activeIndex, setActiveIndex] = useState(NUMBER.ZERO);
    const [progress, setProgress] = useState(NUMBER.TWO);
    const [answerResponse, setAnswerResponse] = useState({
        heading: "",
        subHeading: "",
        type: "error",
        show: false
    });

    const handleQuestionClose = async () => {
        await yieldToMain();
        handleClose();
    };

    const handleOptionClick = ({ key }) => {
        const payload = {
            ga_id: gaId,
            version,
            question_key: questions[activeIndex].key,
            option_key: key
        };
        saveRtoQuestionConnect(payload).then((response) => {
            setAnswerResponse({
                heading: response.title,
                type: response.isValidOption ? "success" : "error",
                subHeading: response.correctAnswer || "",
                show: true
            });
            window.setTimeout(() => {
                const index = activeIndex + NUMBER.ONE;
                setProgress((index / questions.length) * NUMBER.HUNDRED);
                setActiveIndex(index);
                setAnswerResponse({ show: false });
            }, NUMBER.THOUSAND);
        });
    };

    const handleOfferClick = async () => {
        await yieldToMain();
        sendCustomGaEvents({
            event: "rto_challenge_offer_clicked",
            eventCategory: "rto_challenge_offer_clicked",
            eventAction: "Rto Challenge offer clicked"
        });
    };

    return (
        <div styleName={"styles.questionWrapper"}>
            <div styleName={"styles.questionHeader"} className="shrinkOnTouch">
                <Heading level={NUMBER.FOUR}>{questions[NUMBER.ZERO].header}</Heading>
                <CloseButton onClickHandler={() => { handleQuestionClose(); }} />
            </div>
            {
                questions[activeIndex] ?
                    <Fragment>
                        <div styleName={"styles.progressIndicator"}>
                            <ProgressIndicator
                                progressType="continous-bar"
                                type="horizontal"
                                percentage={progress}
                                showProgress={false}
                            />
                        </div>
                        <div styleName={"styles.questions"}>
                            <Label level={NUMBER.TWO} fontWeight="semibold" color={tokens.text_default_text_primary}>{questions[activeIndex].label}</Label>
                            <div styleName={"styles.questionsCard"}>
                                {
                                    questions[activeIndex].images &&
                                    <img src={questions[activeIndex].images} alt={questions[activeIndex].label}  width="140px" height="140px" />
                                }
                                {
                                    questions[activeIndex].options.map((item, index) => (
                                        <React.Fragment key={`rto-questions-${activeIndex}-option-${index}`}>
                                            <Chips
                                                size="large"
                                                type="regular"
                                                label={item.label}
                                                onClick={() => { handleOptionClick(questions[activeIndex].options[index]); }}
                                            />
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </Fragment> :
                    <div styleName={"styles.downloadApp"}>
                        <a href={offer?.redirectionUrl} onClick={handleOfferClick}>
                            <img src={offer?.image} alt={offer?.heading} />
                        </a>
                    </div>
            }
            <div styleName="styles.adsContainerInPage">
                <AdsComponent
                    platformType={getDeviceType().type === "Mobile" ? "MOBILE" : "DESKTOP"}
                    url={`${appUrl()}/rto-vehicle-registration-details/`}
                    slotName= "cars24_rto_traffic_quiz_320x100"
                    bu = "rto"
                    expand = "YES"
                    width = {320}
                    height = {100}
                />
            </div>
            {
                answerResponse && answerResponse.show &&
                <div styleName={"styles.tostMsg"}>
                    <Alert
                        priority="high"
                        {...answerResponse}
                    />
                </div>
            }
        </div>
    );
};

RtoVehInfoQuestionList.propTypes = {
    gaId: PropTypes.string,
    questions: PropTypes.array,
    version: PropTypes.string,
    handleClose: PropTypes.func,
    saveRtoQuestionConnect: PropTypes.func,
    cmsImageGallery: PropTypes.object
};

export default RtoVehInfoQuestionList;
